// 交付方法
export class ReceptionDeliveryKind {
  
  // コード
  code: number;
  // 名称
  name: string;
  // 有効・無効
  isEnable: boolean;

  constructor() {
    this.code = 0;
    this.name = "";
    this.isEnable = true;
  }

  clone(): ReceptionDeliveryKind {
    const newObj = new ReceptionDeliveryKind();
    newObj.code = this.code;
    newObj.name = this.name;
    newObj.isEnable = this.isEnable;

    return newObj;
  }
}
